<template>
	<div class="confirm-order">
		<div class="all-center-box">
			<div class="w-1500">
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				message:{},
			}
		},
		mounted() {
			document.querySelector('body').innerHTML = this.$route.query.pay_sign //查找到当前页面的body，将后台返回的form替换掉body内容
			document.forms[0].submit() ;
		},
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/payment/buyNow.vue